import { render, staticRenderFns } from "./BusinessTransfers.vue?vue&type=template&id=c626a994&scoped=true"
import script from "./BusinessTransfers.vue?vue&type=script&lang=js"
export * from "./BusinessTransfers.vue?vue&type=script&lang=js"
import style0 from "./BusinessTransfers.vue?vue&type=style&index=0&id=c626a994&prod&scoped=true&lang=css"
import style1 from "./BusinessTransfers.vue?vue&type=style&index=1&id=c626a994&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c626a994",
  null
  
)

export default component.exports